/**
 * Behind The Scenes Gallery — shuffled photo-wall placement
 *
 * Mirrors the source's two independent inline-script blocks:
 *   mobile: row = Math.floor(Math.random() * 20), column = Math.floor(Math.random() * 4)
 *   desktop: row = Math.floor(Math.random() * 20), column = Math.floor(Math.random() * 6)
 * Each grid (mobile / desktop) gets its own independent random pass — same
 * as the source, where each breakpoint's photo set was shuffled separately
 * rather than sharing one placement.
 *
 * Note: the source assigns raw 0-19 / 0-3 / 0-5 values directly to
 * style.gridRow / style.gridColumn. CSS grid lines are 1-indexed, so a
 * value of 0 is invalid and the browser ignores it (the item falls back to
 * normal auto-placement for that axis). That quirk is preserved here
 * rather than "fixed" to +1-based values, to match the source exactly.
 */
(function () {
  var sections = document.querySelectorAll('[data-gallery-grid-section]');
  if (!sections.length) return;

  var ROW_MAX = 20; // Math.random() * 20 -> 0-19

  function shuffleGrid(grid, colMax) {
    var items = grid.querySelectorAll('.grid-item');
    items.forEach(function (item) {
      var row = Math.floor(Math.random() * ROW_MAX);
      var col = Math.floor(Math.random() * colMax);
      item.style.gridRow = row;
      item.style.gridColumn = col;
    });
  }

  function shuffleSection(section) {
    var mobileColMax = parseInt(section.getAttribute('data-mobile-col-range'), 10) || 4;
    var desktopColMax = parseInt(section.getAttribute('data-desktop-col-range'), 10) || 6;

    var mobileGrid = section.querySelector('[data-gallery-grid="mobile"]');
    var desktopGrid = section.querySelector('[data-gallery-grid="desktop"]');

    if (mobileGrid) shuffleGrid(mobileGrid, mobileColMax);
    if (desktopGrid) shuffleGrid(desktopGrid, desktopColMax);
  }

  var resizeTimer;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      sections.forEach(shuffleSection);
    }, 150);
  }

  sections.forEach(shuffleSection);
  window.addEventListener('resize', onResize);
})();

class galleryGrid extends HTMLElement {
	constructor() {
        super();
        this.gallerygrid();
    }
	gallerygrid () {
		const galleryItems = gsap.utils.toArray('#gallery-grid .grid-item');
		gsap.to('#gallery-grid .cta-wrapper', {
			scrollTrigger: {
				trigger: '#gallery-grid .cta-wrapper',
				start: 'top +30%',
				endTrigger: '#gallery-grid',
				end: 'bottom bottom',
				scrub: true,
				pin: true,
				pinSpacing: false,
				anticipatePin: 1,
				fastScrollEnd: true,
				toggleActions: 'play reverse play reverse',

				onEnter: () => {
					gsap.to([document.querySelector('#page-component'), '#sections-stack'], {
						backgroundColor: '#13142D',
					});
					gsap.to('#gallery-grid .cta-wrapper', { color: '#ffffff' });
				},
				onLeaveBack: () => {
					gsap.to([document.querySelector('#page-component'), '#sections-stack'], {
						backgroundColor: '#F5F5F5',
					});
					gsap.to('#gallery-grid .cta-wrapper', { color: '#000000' });
				},
			},
		});

		galleryItems.forEach((el, index, array) => {
			const image = el.querySelector('.grid-item-img');
			const yPercentRandomVal = gsap.utils.random(-200, 200);

			gsap.timeline()
				.addLabel('start', 0)
				.set(
					image,
					{
						transformOrigin: `300% 50%`,
					},
					'start'
				)
				.to(
					image,
					{
						ease: 'none',
						startAt: { rotationZ: -30 },
						rotationZ: 30,
						scrollTrigger: {
							trigger: el,
							start: 'top bottom',
							end: 'bottom top',
							scrub: true,
						},
					},
					'start'
				)
				.to(
					el,
					{
						ease: 'none',
						yPercent: yPercentRandomVal,
						scrollTrigger: {
							trigger: el,
							start: 'top bottom',
							end: 'top top',
							scrub: true,
						},
					},
					'start'
				);
		});

	}
}
customElements.define("custom-gallerygrid", galleryGrid);